'use es6';

import { createSelector } from 'reselect';
import { getIsInitialInputFocusDisabled } from '../operators/getIsInitialInputFocusDisabled';
import { getWidgetUiState } from '../../selectors/getWidgetUiState';
export const getShouldDisableInitialInputFocus = createSelector([getWidgetUiState], widgetUiState => getIsInitialInputFocusDisabled(widgetUiState));